export default {
    name: "DEM",
    type: "wmsTiled",
    switcher:{
        "title":"DEM",
        "icon":"/assets/images/DEM.jpg"
    },
    tiled: true,
    layers: [],
    serverType: "geoserver",
    version: "1.1.0",
    format: "image/png",
    url: "/geoserver/wms",
    styles: "",
    visible: false,
    opacity: 1,
    ENV: {min:0,max:0},
    epsg: 5514,
    transition: 1
}